import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";
import renderGlobalAlert from "../../../system/hooks/useGlobalAlert";
import SubstanceByStoreGridPluginSettings from "./SubstanceByStoreGridPluginSettings";
import SubstanceByStoreGrid from "./SubstanceByStoreGrid";

const SubstanceByStoreSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [selectRow, setSelectRow] = useState<ISelectGridRow>()

    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const [entities, setEntities] = useState<IEntitySimpleDTO[]>(props.selectedEntity ?? []);
    const [focusTaken, setFocusTaken] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(false)
    const gridId = uuidv4();
    const plugin = SubstanceByStoreGridPluginSettings
    const { t } = useTranslation();
    

    const isLocked = (isLocked?: boolean) => {
        if (isLocked) {
            renderGlobalAlert({
                variant: "danger",
                title: t('general.goodsIsLocked'),
                statusCode: 500,
            });  
            return false
        }
        return true
    }

    return (
        <GridSelectorModalWindow
            gridDisplayName={t('directory.substance.title')}
            entityToPressEnter={entity}
            focusTaken={focusTaken}
            ok={{
                onClick: () => {
                    if (!isLocked(selectRow?.isLocked)) return
                    props.multipleSelect ? props.ok(entities) : props.ok?.(entity)
                },
                disabled: disabled
            }}
            cancel={{ onClick: () => props.cancel?.() }}>
            {
                plugin
                    ? <SubstanceByStoreGrid
                        gridId={gridId}
                        plugin={plugin}
                        data={entities}
                        isModal
                        baseGridFilter={props.gridFilter}
                        multipleSelect={props.multipleSelect}
                        isSearchForMultyselect={props.isSearchForMultyselect}
                        onFocusChanged={(taken: boolean) => {
                            setFocusTaken(taken);
                        }}
                        onSelect={(row, rowDto) => {
                            if (row && rowDto && rowDto.deleted === false) {
                                setSelectRow(row)
                                setEntity({ idGlobal: row.idGoodsGlobal as string, displayName: row.displayName })
                                setDisabled(false)
                            } else if (row && rowDto && rowDto.deleted === true) {
                                setDisabled(true)
                            } else if (row) {
                                setDisabled(false)
                                setEntity({ idGlobal: row.idGoodsGlobal as string, displayName: row.displayName })
                                setSelectRow(row)
                            }
                        }}
                        onDoubleClick={(row, rowDto) => {
                            if (!isLocked(row?.isLocked)) return
                            if (row && rowDto && rowDto.deleted === false) {
                                setEntity({ idGlobal: row.idGoodsGlobal as string, displayName: row.displayName })
                                props.ok?.({ idGlobal: row.idGoodsGlobal as string, displayName: row.displayName })
                            }
                        }}
                        onMultipleSelect={(rows) => {
                            rows && setEntities(rows.map(x => ({ idGlobal: x.idGoodsGlobal as string, displayName: x.displayName } as IEntitySimpleDTO)))
                        }}
                    />
                    : <p> {t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default SubstanceByStoreSelectorModal